import { createI18n } from 'vue-i18n';
import en from '../locales/en.json';
import de from '../locales/de.json';

// Browser language detection
function detectBrowserLanguage(): string {
  const browserLang = navigator.language || (navigator as any).userLanguage;
  const lang = browserLang?.toLowerCase().split('-')[0];
  return lang === 'de' ? 'de' : 'en'; // Only support de/en, fallback to en
}

// Supported locales
export const SUPPORTED_LOCALES = ['en', 'de'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];
export const DEFAULT_LOCALE: SupportedLocale = 'en';

// Locale display names
export const LOCALE_NAMES: Record<SupportedLocale, string> = {
  en: 'English',
  de: 'Deutsch',
};

export function createI18nInstance(initialLocale?: string) {
  const locale = initialLocale || detectBrowserLanguage();

  return createI18n({
    legacy: false, // Use Composition API
    locale: SUPPORTED_LOCALES.includes(locale as any) ? locale : DEFAULT_LOCALE,
    fallbackLocale: DEFAULT_LOCALE,
    messages: {
      en,
      de,
    },
    missingWarn: false, // Don't warn about missing keys in production
    fallbackWarn: false,
  });
}
